import React from 'react';
import {FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import SidebarSubMenu from './SidebarSubMenu';
import styled from 'styled-components';
import logo from '../../assets/logo.png';
import SocialIcons from './SocialIcons';
import { FaHome } from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeContext';

// Sidebar width variable
const sidebarWidth = '250px';

const SidebarNav = styled.nav`
  background: var(--current-background);
  width: ${sidebarWidth};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: fixed;
  top: 0;
  left: ${({ open }) => (open ? '0' : `-${sidebarWidth}`)};
  transition: background-color 0.25s, left 500ms;
  z-index: 1001;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.2);
`;

const SidebarHeader = styled.div`
  background: var(--current-header-footer); /* Matches header color */
  color: var(--current-text);
  text-align: center;
  padding: 0.5rem 1.5rem;
  height: 2rem;
  border-bottom: 1px solid var(--border-color);
`;

const SidebarContent = styled.div`
  flex: 1;
  overflow-y: auto;
  background: var(--current-background); /* Middle section can have a different background */
`;

const SidebarFooter = styled.div`
  background: var(--current-header-footer); /* Matches footer color */
  color: var(--current-text);
  height: 1.5rem;
  padding: 0.5rem 1rem;
  text-align: center;
  border-top: 1px solid var(--border-color);
`;

const ToggleButton = styled.div`
  position: fixed;
  left: ${({ open }) => (open ? `calc(${sidebarWidth} - 0.8125rem)` : '0.1875rem')};
  top: 50%; 
  height: 1.875rem;
  width: 0.625rem;
  background: var(--toggle-button-color); 
  cursor: pointer;
  z-index: 1002;
  transition: left 500ms;
  border-radius: 40%; // Makes it rounded like a tic-tac

  &:hover {
    width: 1.6rem; // Expand for the icon
    background  : -var(--toggle-button-color); 
    justify-content: center; 
    align-items: center; 
    color: var(--toggle-svg-color);
  }

  &:hover svg {
    opacity: 1; // Show the icon when hovered
    transition: opacity 250ms;
    background: -var(--toggle-svg-color);
    color: var(--toggle-svg-color);
  }

  svg {
    opacity: 0; // Hide the icon when not hovered
    transition: opacity 250ms;
  }
`;

const LogoImage = styled.img`
  width: 2rem;
  height: auto;
  // margin: 1rem;
  // display: block;
`;


const Sidebar = ({ components, open, toggleSidebar }) => {
  const { darkMode } = useTheme();
  console.log('darkMode', darkMode);
  // Add home and components to the sidebar
  const SidebarData = [
    {
      title: 'Home',
      path: '/',
      icon: <FaHome></FaHome>,
      cName: 'nav-text'
    },
    ...components.map(component => ({
      title: component.name,
      path: component.path,
      icon: component.icon,
      cName: 'nav-text'
    }))
  ];

  return (
    <>
      <SidebarNav 
        open={open}
        role="navigation"
        aria-label="Main navigation"
      >
        <SidebarHeader>
          <LogoImage 
            src={logo} 
            alt="Company Logo" 
            width="150"
            height="50"
          />
        </SidebarHeader>
        <SidebarContent>
          {SidebarData.map((item, index) => (
            <SidebarSubMenu 
              item={item} 
              key={item.path} 
              tabIndex={0}
              role="menuitem"
              aria-label={item.title}
            />
          ))}
        </SidebarContent>
        <SidebarFooter>
          <SocialIcons />
        </SidebarFooter>
      </SidebarNav>
      <ToggleButton 
        open={open} 
        onClick={toggleSidebar}
        aria-label="Toggle sidebar"
        aria-expanded={open}
      >
        {open ? 
          <FaAngleLeft style={{ color: 'var(--text-light)', fontSize: '1.75rem' }} /> : 
          <FaAngleRight style={{ color: 'var(--text-light)', fontSize: '1.75rem' }} />
        }
      </ToggleButton>
    </>
  );
};

export default Sidebar;
